module.exports = __webpack_public_path__ + "static/c-4-6f529a20f9bfb2e5985db77090cae2b4.jpg";